import React from 'react';
import { TruckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import Spinner from './Spinner'; // Import a spinner component

const CustomerVehiclesModal = ({ vehicles, onClose, isLoading }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gradient-to-br from-gray-900/80 via-gray-900/70 to-gray-900/80 backdrop-blur-sm overflow-auto p-4">
      <div className="bg-white w-full max-w-6xl rounded-2xl shadow-2xl max-h-[90vh] overflow-hidden flex flex-col transform transition-all duration-300 animate-fadeIn">
        {/* Header with gradient background */}
        <div className="relative bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-600 px-8 py-6">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/20 rounded-lg p-2 transition-all duration-200"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
          <h2 className="text-3xl font-bold text-white flex items-center gap-3">
            <div className="bg-white/20 backdrop-blur-sm p-3 rounded-xl">
              <TruckIcon className="h-8 w-8 text-white" />
            </div>
            Customer Vehicles
          </h2>
          <p className="mt-2 text-emerald-100 text-sm">
            View all registered vehicles for this customer
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-8 py-6">
          {isLoading ? (
            <div className="flex flex-col justify-center items-center h-64">
              <Spinner />
              <p className="mt-4 text-gray-500 font-medium">Loading vehicles...</p>
            </div>
          ) : vehicles && vehicles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {vehicles.map((vehicle, index) => (
                <div
                  key={index}
                  className="group relative bg-gradient-to-br from-gray-50 to-gray-100 border-2 border-gray-200 rounded-xl p-6
                  hover:border-emerald-400 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                  {/* Vehicle Icon Badge */}
                  <div className="absolute -top-3 -right-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-full p-2 shadow-lg">
                    <TruckIcon className="h-5 w-5" />
                  </div>

                  <div className="space-y-3">
                    <div className="flex items-center gap-2 pb-3 border-b-2 border-emerald-200">
                      <span className="text-xs font-bold text-emerald-700 bg-emerald-100 px-2 py-1 rounded">
                        Vehicle #{index + 1}
                      </span>
                    </div>

                    <div className="space-y-2">
                      {vehicle?.GIN && (
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-semibold text-gray-600">GIN:</span>
                          <span className="text-sm text-gray-800 font-mono bg-white px-2 py-1 rounded">{vehicle.GIN}</span>
                        </div>
                      )}
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-semibold text-gray-600">VIN:</span>
                        <span className="text-sm text-gray-800 font-mono bg-white px-2 py-1 rounded">{vehicle.VIN}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm font-semibold text-gray-600">Registration:</span>
                        <span className="text-sm text-gray-800 font-semibold">{vehicle.registrationNumber}</span>
                      </div>
                      <div className="pt-2 border-t border-gray-300">
                        <div className="flex justify-between items-center mb-1">
                          <span className="text-sm font-semibold text-gray-600">Make:</span>
                          <span className="text-sm text-gray-800 font-semibold">{vehicle.vehicleMake}</span>
                        </div>
                        <div className="flex justify-between items-center mb-1">
                          <span className="text-sm font-semibold text-gray-600">Model:</span>
                          <span className="text-sm text-gray-800 font-semibold">{vehicle.vehicleModel}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm font-semibold text-gray-600">Year:</span>
                          <span className="text-sm text-gray-800 font-semibold">{vehicle.year}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-64 text-gray-500">
              <TruckIcon className="h-20 w-20 text-gray-300 mb-4" />
              <p className="text-lg font-semibold">No Vehicles Found</p>
              <p className="text-sm">This customer has no registered vehicles.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-8 py-4 bg-gray-50 border-t border-gray-200">
          <button
            className="w-full px-6 py-3.5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold rounded-xl
            hover:from-emerald-700 hover:to-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500
            transform transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerVehiclesModal;
